import { Route, Routes } from "react-router-dom";
import Main from './pages/main'
import './style.css'
import './tradutor/Tradutor'

export default function App(){
  

  return(
    <Routes>
      <Route path='/' element={<Main/>}/>
    </Routes>
  )
}



